// Shows on dashboard home
import { useState, useEffect } from "react";
import { sortByDate } from "../functions/sortByDate";
import { GetUsers } from "../functions/GetUsers";



export default function RecentUsers() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    (async () => {
      setUsers(await GetUsers());
    })();
  }, []);

  console.log(users);

  // formate prop.dateCreated and save in var
  

  return (
    <>
      <div className="dashboard_heading">
        <span style={{ flex: 1, margin: "5px 0", fontSize: 22 }}>Date</span>
        <span style={{ flex: 1, margin: "5px 0", fontSize: 22 }}>Name</span>
        <span style={{ flex: 1, margin: "5px 0", fontSize: 22 }}>Community</span>
        <span style={{ flex: 1, margin: "5px 0", fontSize: 22 }}>Role</span>
      </div>
      {sortByDate(users).map((prop, i) => {
        // Convert Firebase timestamp to JavaScript Date object
        let dateCreated = new Date(prop.dateCreated.toDate());
        
        // Format the date as you like
        let formattedDate = dateCreated.toLocaleDateString("en-US"); // format as MM/DD/YYYY
        return (
          <div key={i} className="dashboard_datarow">

            <div style={{ flex: 1, margin: "1em 0",}}>
            {formattedDate}
              </div>
         <div style={{ flex: 1, margin: "1em 0",}}>
              {prop.firstName + " " + prop.lastName}
            </div>

            <div style={{ flex: 1, margin: "1em 0" }}>{prop.community}</div>

            <div style={{ flex: 1, margin: "1em 0" }}>{prop.userTypeName}</div>
          </div>
        );
      })}
    </>
  );
}
